import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import produce from 'immer';
import { Form, Validator } from '../widgets';
import { useOrganization } from './context/OrganizationContext';
import LogoUpload from './LogoUpload';
import Theme from './Theme';
import { validateOrganizationForm } from './utils';
import { ORGANIZATION_FONT_FAMILY, ORGANIZATION_FONT_SIZES, ORGANIZATION_FONT_WEIGHT } from '../../constants';

const OrganizationForm = () => {

    const { organizationState: state, setOrganizationState: handleChange } = useOrganization();
    const { organizationName, uiConfig } = state;
    const { isLogoVisible, isOrganizationVisible, isFarmVisible, organizationFontSize, organizationFontFamily, organizationFontWeight } = uiConfig || {};

    const handleOrganizationChange = (e) => {
        const newOrganizationName = e.target.value;
        const newState = produce(state, s => {
            s.organizationName = newOrganizationName;
            s.validation = validateForm({ organizationName: newOrganizationName });
        })
        handleChange(newState);
    }

    const handleLogoVisibleChange = () => handleUiConfigChange('isLogoVisible', !isLogoVisible);

    const handleOrganizationVisibleChange = () =>
        handleUiConfigChange('isOrganizationVisible', !isOrganizationVisible);

    const handleFarmVisibleChange = () =>
        handleUiConfigChange('isFarmVisible', !isFarmVisible);


    const handleFontSizeChange = (selected) =>
        selected && handleUiConfigChange('organizationFontSize', selected.value);

    const handleFontWeightChange = (selected) =>
        selected && handleUiConfigChange('organizationFontWeight', selected.value);

    const handleFontFamilyChange = (selected) =>
        selected && handleUiConfigChange('organizationFontFamily', selected.value);


    const handleUiConfigChange = (key, value) => {
        const newState = produce(state, s => {
            s.uiConfig[key] = value;
        })
        handleChange(newState);
    }

    const validateForm = data => state.isSubmitted
        ? validateOrganizationForm(state.validator, data) : state.validation;

    const organizationValidation = (state.validation || {}).organizationName || {};
    return (
        <div className="org-form-container">
            <Row className='mx-0'>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Form.Label>Logo <span className="org-sub-lbl">(Recommended transparent image with maximum height of 40px)</span></Form.Label>
                        <LogoUpload />
                    </FormGroup>
                </Col>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Form.Check
                            type="switch"
                            id="logo-switch"
                            className="org-toggle-switch logo"
                            label="Hide Logo"
                            checked={!isLogoVisible}
                            onChange={handleLogoVisibleChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className='mx-0'>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Validator validation={organizationValidation}>
                            <Form.Label>Organization Name</Form.Label>
                            <Form.Control maxLength={30} size='sm' type="text" id="organization" autoComplete="off"
                                name="organizationName" value={organizationName || ''} onChange={handleOrganizationChange} />
                            <Validator.Text />
                        </Validator>
                    </FormGroup>
                </Col>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup className="org-switch-container">
                        <Form.Check
                            type="switch"
                            id="name-switch"
                            label="Hide Organization Name"
                            className="org-toggle-switch name"
                            checked={!isOrganizationVisible}
                            onChange={handleOrganizationVisibleChange}
                        />
                        <Form.Check
                            type="switch"
                            id="farm-switch"
                            label="Hide Farm Name"
                            className="org-toggle-switch frm-name"
                            checked={!isFarmVisible}
                            onChange={handleFarmVisibleChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className='mx-0'>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Form.Label className="org-form-label">Organization Name font family</Form.Label>

                        <Form.Select className="select-control-sm" placeholder="Select font family"
                            isClearable={false}
                            value={organizationFontFamily} onChange={handleFontFamilyChange}
                            options={ORGANIZATION_FONT_FAMILY}>
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row className='mx-0'>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Form.Label className="org-form-label">Organization Name font size</Form.Label>
                        <Form.Select className="select-control-sm" placeholder="Select font size"
                            isClearable={false}
                            value={organizationFontSize} onChange={handleFontSizeChange}
                            options={ORGANIZATION_FONT_SIZES}>
                        </Form.Select>

                    </FormGroup>
                </Col>
            </Row>
            <Row className='mx-0'>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Form.Label className="org-form-label">Organization Name font weight</Form.Label>
                        <Form.Select className="select-control-sm" placeholder="Select font weight"
                            isClearable={false}
                            value={organizationFontWeight} onChange={handleFontWeightChange}
                            options={ORGANIZATION_FONT_WEIGHT}>
                        </Form.Select>
                    </FormGroup>
                </Col>
            </Row>
            <Row className='mx-0'>
                <Col lg={4} md={4} sm={12} xs={12}>
                    <FormGroup>
                        <Form.Label className="org-form-label">Theme</Form.Label>
                        <Theme />
                    </FormGroup>
                </Col>
            </Row>
        </div>
    )
}

export default OrganizationForm;
